import * as AT from 'redux/actionTypes/index';
// eslint-disable-next-line import/no-cycle
import sessionCoordinator, {
  TOKEN_RENEWAL_LEAD_TIME_MS,
  TOKEN_RENEWAL_RETRY_DELAYS_MS,
} from 'utils/auth/sessionCoordinator';

const authMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case AT.LOGIN_SUCCESS: {
      sessionCoordinator.bindDispatch(store.dispatch);
      const record = sessionCoordinator.onLoginSuccess(action.payload);
      fullStoryIntegration(action.payload.profile.name, action.payload.profile.labId);
      return next({
        ...action,
        payload: {
          ...action.payload,
          issuedAt: record.issuedAt,
          expiresAt: record.expiresAt,
          generationId: record.generationId,
          sessionStatus: 'authenticated',
        },
      });
    }
    case AT.LOGOUT:
      sessionCoordinator.bindDispatch(store.dispatch);
      void Promise.resolve(sessionCoordinator.handleExplicitLogout()).then((didLogout) => {
        if (didLogout) {
          next(action);
        }
      });
      return undefined;
    case AT.TRY_AUTHENTICATE_FROM_LOCAL_STORAGE:
      sessionCoordinator.bindDispatch(store.dispatch);
      sessionCoordinator.bootstrap(action.payload);
      break;
    default:
  }
  return next(action);
};

export const recoverAuthenticationSession = async (dispatch) => {
  sessionCoordinator.bindDispatch(dispatch);
  const record = await sessionCoordinator.recoverAuthenticationSession();
  if (!record) {
    return null;
  }

  return {
    accessToken: record.accessToken,
    expiresAt: record.expiresAt,
    scope: record.scope,
    issuedAt: record.issuedAt,
    generationId: record.generationId,
  };
};

const fullStoryIntegration = (userName, labId) => {
  const fullStory = window.FS;
  if (fullStory) {
    fullStory.identify(userName, {
      displayName: userName,
      // eslint-disable-next-line camelcase
      lab_id: labId,
    });
  }
};

export { TOKEN_RENEWAL_LEAD_TIME_MS, TOKEN_RENEWAL_RETRY_DELAYS_MS };
export default authMiddleware;
